<template>
  <div>
    <loader v-if="loading" />
    <div
      v-else-if="!filteredList.length"
      class="empty-list"
    >
      <v-icon
        color="light-gray"
        x-large
      >
        mdi-lightning-bolt-outline
      </v-icon>

      <div>No active charging sessions right now</div>
    </div>
    <div v-else>
      <div class="sec-label">
        Charging now · {{ filteredList.length }} session{{
          filteredList.length > 1 ? "s" : ""
        }}
      </div>
      <div class="list">
        <div
          v-for="(bk, index) in filteredList"
          :key="`bk-${index}`"
          :class="[
            'bk-card bk-card--active bk-card--live-card',
            {
              'bk-card--sel':
                selectedBooking &&
                selectedBooking.charge_session?.session_id ===
                  bk.charge_session?.session_id,
            },
          ]"
          @click="$emit('open-live-detail', bk)"
        >
          <!-- <div class="stripe" />  -->
          <div class="bk-id-row">
            <span
              v-if="bk.booking_id"
              class="bk-id-badge"
            >
              Booking No: {{ bk.booking_id }}
            </span>
            <span
              v-else
              class="bk-id-badge"
            >
              Walk-In Customer
            </span>
            <span
              v-if="bk?.current_status === 'charging'"
              class="live-tag"
            >
              <span class="live-pulse live-pulse--sm" />LIVE
            </span>
            <span
              v-else-if="bk?.current_status != 'charging'"
              :class="['live-tag pill text-uppercase', pillClass('due_now')]"
            >
              Collect Payment
            </span>
          </div>
          <div class="bk-top">
            <div>
              <div class="bk-time">
                {{ bk.start_time_format }}
                <!-- <span class="ampm"> {{ bk.ampm }}</span> -->
              </div>
              <div class="bk-sub">
                {{ bk.current_status }}...
                {{ bk?.charge_session?.start_soc || 0 }}% →
                {{ bk?.charge_session?.end_soc || 0 }}%
              </div>
            </div>
            <span
              :class="['pill text-uppercase', pillClass(bk.current_status)]"
            >
              <span class="dot" />
              {{ bk.current_status.replace("_", " ") }}
            </span>
          </div>
          <div class="bk-body">
            <div class="avatar">
              {{ bk.customer_name[0] }}
            </div>
            <div class="bk-info">
              <div class="bk-name">
                {{ bk.customer_name }}
              </div>
              <div class="bk-veh">
                <span class="reg-tag">{{ bk.vehicle_reg_no }} </span>
              </div>
              <div class="b-veh-model">
                {{ bk.vehicle_make_name }} - {{ bk.vehicle_model_name }}
              </div>
            </div>
            <div class="bk-port">
              <div class="port-num">
                Gun-{{ bk.connector_no | returnAlpha }}
              </div>
              <div class="port-type">
                {{ bk.connector_type }} - {{ bk.connector_power }}kW
              </div>
            </div>
            <v-icon class="chev">
              mdi-chevron-right
            </v-icon>
          </div>
          <div class="live-stats">
            <div class="live-stat">
              <div class="live-stat__val">
                {{ bk?.charge_session?.energy_consumed || 0 }}
                <span class="live-stat__unit">kWh</span>
              </div>
              <div class="live-stat__lbl">
                Delivered
              </div>
            </div>
            <div class="live-stat-div" />
            <div class="live-stat">
              <!-- {{ convertDuration(bk?.charge_session?.duration_minutes) }} -->
              <div class="live-stat__val">
                <span
                  v-for="(r, i) in convertDuration(
                    bk?.charge_session?.duration_minutes
                  )"
                  :key="i"
                >
                  {{ r.value }}
                  <span class="live-stat__unit">{{ r.unit }}</span>
                </span>
              </div>

              <div class="live-stat__lbl">
                Elapsed
              </div>
            </div>
            <div class="live-stat-div" />
            <div class="live-stat">
              <div class="live-stat__val">
                {{ bk?.charge_session?.total_cost || 0 }}
                <span class="live-stat__unit">
                  {{ bk?.charge_session?.currency }}
                </span>
              </div>
              <div class="live-stat__lbl">
                Amount
              </div>
            </div>
          </div>
          <div
            v-if="bk.slot_duration_minutes"
            class="bk-duration"
          >
            <v-icon small>
              mdi-clock-time-three-outline
            </v-icon>
            {{ bk.slot_duration_minutes }} min booking slot &nbsp;·&nbsp; Until
            {{ bk.end_time_format }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { convertDuration, pillClass } from "../utils/bookingHelpers";

export default {
  name: "LiveTab",
  components: {
    Loader: () => import("../utils/Loader.vue"),
  },
  props: {
    selectedBooking: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "bookingOperator/getLoading",
      list: "bookingOperator/getLiveSession",
    }),
    filteredList() {
      // Dont's show unmaped Walk in Sessions in Live Tab
      const arr = this.list.filter((r) => r.vehicle_reg_no);
      return arr;
    },
  },
  beforeDestroy() {
    if (this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    convertDuration,
    pillClass,
    fetchData() {
      clearTimeout(this.interval);
      //
      const params = { filter_type: "live" };
      this.$store.dispatch(`bookingOperator/list`, params);
      //
      this.interval = setTimeout(this.fetchData, 15000);
    },
  },
};
</script>
<style scoped></style>
